<div class="not-found-container position-relative w-100 min-vh-100 overflow-hidden d-flex flex-column align-items-center justify-content-center">
  <div class="scene position-absolute top-0 start-0 w-100 h-100 overflow-hidden pe-none" aria-hidden="true">
    @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
      <div class="star star-{{ i }} position-absolute text-white">{{ i === 7 ? '✧' : '✦' }}</div>
    }
    <div class="shooting-star position-absolute rounded-circle"></div>
    <div class="hotel-building position-absolute d-flex flex-column align-items-center">
      <div class="hotel-roof">🏨</div>
      <div class="window-grid d-grid">
        <div class="window lit rounded-1"></div>
        <div class="window rounded-1"></div>
        <div class="window lit rounded-1"></div>
        <div class="window rounded-1"></div>
        <div class="window rounded-1"></div>
        <div class="window lit rounded-1"></div>
        <div class="window lit rounded-1"></div>
        <div class="window rounded-1"></div>
        <div class="window rounded-1"></div>
      </div>
    </div>
    <div class="door-sign position-absolute">🚪</div>
  </div>

  <div class="content position-relative text-center p-3" role="main">
    <h1 class="error-code fw-bold m-0 lh-1 text-white">404</h1>
    <h2 class="error-title fw-semibold">This room doesn't exist</h2>
    <p class="error-message mx-auto">
      Looks like this page checked out early.
      Let's get you back to finding your perfect stay.
    </p>
    <app-button
      variant="primary"
      label="Browse Rooms"
      ariaLabel="Browse available rooms"
      (onClickEvent)="goHome()"
    />
  </div>

  <div class="ground position-absolute bottom-0 start-0 w-100 d-flex align-items-center justify-content-center gap-4" aria-hidden="true">
  </div>
</div>
